import React, {useEffect, useState} from "react";
import CFAdminDataTable from "../../components/CFAdminDataTable";
import SysMaintainenceService from "../../services/SysMaintainenceService";

function CFAdminLanguages() {

    const [data, setData] = useState([]);
    const columns =  [
        {
            Header : "Id",
            accessor : 'id'
        },
        {
            Header : "Description",
            accessor : 'admin'
        },
        {
            Header : "ISO Code",
            accessor : 'isoCode'
        },
        {
            Header : "Last Modified By",
            accessor : 'userKey'
        },
        {
            Header : "Last Modified Date",
            accessor : 'modified'
        },
    ];

    useEffect(() => {
        retrieveLanguages();
    }, []);



    const retrieveLanguages = async () => {
        SysMaintainenceService.getAllLanguages()
            .then(response => {
                setData(response.data.languagesResponseModel);
            })
            .catch(e => {
                console.log(e);
            });
    };

    return (
        <>
          <h2 className="fomo-type--title">Manage Languages</h2>
            <CFAdminDataTable
                columns={columns}
                data={data}
                toggleModal={''}
                textModal={'none'}
            />
        </>
      );
  }
  
  export default CFAdminLanguages;